import {useNavigate} from "react-router-dom";
import {Box, Button, CardContent, Typography} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import I18n from "i18n-js";
import React from "react";
import {Card} from "common";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export enum ActivationMessageType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export interface ActivationMessageProps {
  onlyContent?: boolean;
  onBack?: Function;
  type: ActivationMessageType;
  messageCategory: string;
}

export default function ActivationMessage({onlyContent = false, onBack, type, messageCategory}: ActivationMessageProps) {
  const navigate = useNavigate();

  function getContent() {
    return (
      <>
        {
          type === ActivationMessageType.SUCCESS
            ? <CheckCircleOutlineIcon sx={{fontSize: 60, color: "#4caf50", mb: 2}}/>
            : <ErrorOutlineIcon sx={{fontSize: 60, color: "#f44336", mb: 2}}/>
        }
        <Typography variant="h5" gutterBottom>
          {I18n.t(`${messageCategory}.title`)}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{mb: 3}}>
          {I18n.t(`${messageCategory}.description`)} <br/>
          {I18n.t(`${messageCategory}.description2`)}
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            if (onBack) {
              onBack();
            }

            navigate('/');
          }}
        >
          {I18n.t(`${messageCategory}.back`)}
        </Button>
      </>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        margin: "0 auto",
        padding: 2,
        textAlign: "center"
      }}
    >
      {
        onlyContent
          ? getContent()
          : (
            <Card
              sx={{
                minWidth: "400px",
              }}
            >
              <CardContent sx={{textAlign: "center"}}>
                {getContent()}
              </CardContent>
            </Card>
          )
      }
    </Box>
  );
}